import React from 'react';

// Icon component wrapper for consistent sizing
const Icon = ({ children, size = 16, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {children}
  </svg>
);

// Tools icon (wrench)
export const ToolsIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M14.25 4.75L11.5 7.5L9 5L11.75 2.25C10.9167 1.75 9.91667 1.5 8.75 1.5C5.85 1.5 3.5 3.85 3.5 6.75C3.5 7.35 3.6 7.92 3.78 8.45L1.5 10.73C1.18 11.05 1 11.48 1 11.93C1 12.92 1.79 13.71 2.78 13.71C3.23 13.71 3.66 13.53 3.98 13.21L6.26 10.93C6.79 11.11 7.36 11.21 7.96 11.21C10.86 11.21 13.21 8.86 13.21 5.96C13.21 4.84 12.87 3.8 12.31 2.93L14.25 4.75Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </Icon>
);

// Settings/Gear icon
export const SettingsIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M12.93 10C12.84 10.22 12.82 10.46 12.88 10.69C12.94 10.92 13.07 11.12 13.26 11.27L13.31 11.31C13.46 11.43 13.58 11.58 13.67 11.75C13.76 11.92 13.81 12.11 13.81 12.31C13.81 12.51 13.76 12.7 13.67 12.87C13.58 13.04 13.46 13.19 13.31 13.31C13.19 13.46 13.04 13.58 12.87 13.67C12.7 13.76 12.51 13.81 12.31 13.81C12.11 13.81 11.92 13.76 11.75 13.67C11.58 13.58 11.43 13.46 11.31 13.31L11.27 13.26C11.12 13.07 10.92 12.94 10.69 12.88C10.46 12.82 10.22 12.84 10 12.93C9.78 13.01 9.6 13.16 9.47 13.35C9.34 13.54 9.27 13.77 9.27 14V14.12C9.27 14.53 9.11 14.92 8.82 15.21C8.53 15.5 8.14 15.66 7.73 15.66C7.32 15.66 6.93 15.5 6.64 15.21C6.35 14.92 6.19 14.53 6.19 14.12V14.06C6.18 13.82 6.1 13.58 5.95 13.39C5.8 13.2 5.6 13.06 5.37 12.99C5.14 12.93 4.9 12.95 4.69 13.04C4.47 13.13 4.29 13.28 4.16 13.48L4.12 13.53C3.97 13.68 3.82 13.8 3.65 13.89C3.48 13.98 3.29 14.03 3.09 14.03C2.89 14.03 2.7 13.98 2.53 13.89C2.36 13.8 2.21 13.68 2.09 13.53C1.94 13.41 1.82 13.26 1.73 13.09C1.64 12.92 1.59 12.73 1.59 12.53C1.59 12.33 1.64 12.14 1.73 11.97C1.82 11.8 1.94 11.65 2.09 11.53L2.14 11.49C2.33 11.34 2.46 11.14 2.52 10.91C2.58 10.68 2.56 10.44 2.47 10.22C2.39 10 2.24 9.82 2.05 9.69C1.86 9.56 1.63 9.49 1.4 9.49H1.28C0.87 9.49 0.48 9.33 0.19 9.04C-0.1 8.75 -0.26 8.36 -0.26 7.95C-0.26 7.54 -0.1 7.15 0.19 6.86C0.48 6.57 0.87 6.41 1.28 6.41H1.34C1.58 6.4 1.82 6.32 2.01 6.17C2.2 6.02 2.34 5.82 2.41 5.59C2.47 5.36 2.45 5.12 2.36 4.91C2.27 4.69 2.12 4.51 1.93 4.38L1.88 4.34C1.73 4.22 1.61 4.07 1.52 3.9C1.43 3.73 1.38 3.54 1.38 3.34C1.38 3.14 1.43 2.95 1.52 2.78C1.61 2.61 1.73 2.46 1.88 2.34C2 2.19 2.15 2.07 2.32 1.98C2.49 1.89 2.68 1.84 2.88 1.84C3.08 1.84 3.27 1.89 3.44 1.98C3.61 2.07 3.76 2.19 3.88 2.34L3.92 2.39C4.07 2.58 4.27 2.71 4.5 2.77C4.73 2.83 4.97 2.81 5.19 2.72H5.25C5.47 2.64 5.65 2.49 5.78 2.3C5.91 2.11 5.98 1.88 5.98 1.65V1.53C5.98 1.12 6.14 0.73 6.43 0.44C6.72 0.15 7.11 -0.01 7.52 -0.01C7.93 -0.01 8.32 0.15 8.61 0.44C8.9 0.73 9.06 1.12 9.06 1.53V1.59C9.06 1.82 9.13 2.05 9.26 2.24C9.39 2.43 9.57 2.58 9.79 2.66C10.01 2.72 10.25 2.7 10.47 2.61C10.69 2.52 10.87 2.37 11 2.18L11.04 2.13C11.16 1.98 11.31 1.86 11.48 1.77C11.65 1.68 11.84 1.63 12.04 1.63C12.24 1.63 12.43 1.68 12.6 1.77C12.77 1.86 12.92 1.98 13.04 2.13C13.19 2.25 13.31 2.4 13.4 2.57C13.49 2.74 13.54 2.93 13.54 3.13C13.54 3.33 13.49 3.52 13.4 3.69C13.31 3.86 13.19 4.01 13.04 4.13L12.99 4.17C12.8 4.32 12.67 4.52 12.61 4.75C12.55 4.98 12.57 5.22 12.66 5.44V5.5C12.74 5.72 12.89 5.9 13.08 6.03C13.27 6.16 13.5 6.23 13.73 6.23H13.85C14.26 6.23 14.65 6.39 14.94 6.68C15.23 6.97 15.39 7.36 15.39 7.77C15.39 8.18 15.23 8.57 14.94 8.86C14.65 9.15 14.26 9.31 13.85 9.31H13.79C13.56 9.31 13.33 9.38 13.14 9.51C12.95 9.64 12.8 9.82 12.72 10.04L12.93 10Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </Icon>
);

// Lightning/Execute icon
export const ExecuteIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M8.5 1.5L3 9H8L7.5 14.5L13 7H8L8.5 1.5Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </Icon>
);

// Robot/Agent icon - supports 2-tone coloring
export const AgentIcon = ({ size = 16, color = 'currentColor', colorSecondary = null }) => {
  // If no secondary color provided, use the primary color
  const fillColor = colorSecondary || color;
  return (
    <Icon size={size}>
      <rect x="3" y="5" width="10" height="9" rx="2" stroke={color} strokeWidth="1.5"/>
      <circle cx="6" cy="9" r="1" fill={fillColor}/>
      <circle cx="10" cy="9" r="1" fill={fillColor}/>
      <path d="M6 12H10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M8 5V3" stroke={colorSecondary || color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M6 3H10" stroke={colorSecondary || color} strokeWidth="1.5" strokeLinecap="round"/>
    </Icon>
  );
};

// Folder icon
export const FolderIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M2 5.5C2 4.39543 2.89543 3.5 4 3.5H6L7.5 5.5H12C13.1046 5.5 14 6.39543 14 7.5V11.5C14 12.6046 13.1046 13.5 12 13.5H4C2.89543 13.5 2 12.6046 2 11.5V5.5Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </Icon>
);

// Save/Disk icon
export const SaveIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M12.5 14.5H3.5C2.94772 14.5 2.5 14.0523 2.5 13.5V2.5C2.5 1.94772 2.94772 1.5 3.5 1.5H10.5L13.5 4.5V13.5C13.5 14.0523 13.0523 14.5 12.5 14.5Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path d="M5 1.5V5.5H10V1.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 14.5V9.5H11V14.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

// Open/Upload icon
export const OpenIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M14 11V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V11" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path d="M5 6L8 3L11 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 3V11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

// Trash/Delete icon
export const TrashIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path d="M2.5 4.5H13.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path 
      d="M5.5 4.5V3C5.5 2.44772 5.94772 2 6.5 2H9.5C10.0523 2 10.5 2.44772 10.5 3V4.5" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M12.5 4.5V13.5C12.5 14.0523 12.0523 14.5 11.5 14.5H4.5C3.94772 14.5 3.5 14.0523 3.5 13.5V4.5" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </Icon>
);

// Swarm/Bees icon
export const SwarmIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <circle cx="8" cy="4" r="2" stroke={color} strokeWidth="1.5"/>
    <circle cx="4" cy="10" r="2" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="10" r="2" stroke={color} strokeWidth="1.5"/>
    <path d="M8 6V8L6 9" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 8L10 9" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Graph/Network icon
export const GraphIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <circle cx="4" cy="4" r="2" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="4" r="2" stroke={color} strokeWidth="1.5"/>
    <circle cx="8" cy="12" r="2" stroke={color} strokeWidth="1.5"/>
    <path d="M5.5 5.5L7 10.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10.5 5.5L9 10.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M6 4H10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Plus icon
export const PlusIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path d="M8 3V13" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M3 8H13" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Close/X icon
export const CloseIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path d="M4 4L12 12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 4L4 12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Search icon
export const SearchIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <circle cx="7" cy="7" r="4" stroke={color} strokeWidth="1.5"/>
    <path d="M10 10L13 13" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Chevron Down icon
export const ChevronDownIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path d="M4 6L8 10L12 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

// Target/Single Agent icon  
export const TargetIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5"/>
    <circle cx="8" cy="8" r="3" stroke={color} strokeWidth="1.5"/>
    <circle cx="8" cy="8" r="1" fill={color}/>
  </Icon>
);

// Edit/Pencil icon
export const EditIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M11.5 2.5L13.5 4.5L5 13H3V11L11.5 2.5Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path d="M10 4L12 6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Lightbulb/Tip icon
export const LightbulbIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M8 2C5.79 2 4 3.79 4 6C4 7.54 4.8 8.88 6 9.63V11C6 11.55 6.45 12 7 12H9C9.55 12 10 11.55 10 11V9.63C11.2 8.88 12 7.54 12 6C12 3.79 10.21 2 8 2Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path d="M7 14H9" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Info/Circle icon
export const InfoIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5"/>
    <path d="M8 11V8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="8" cy="5.5" r="0.75" fill={color}/>
  </Icon>
);

// Chat/Message icon
export const ChatIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M3 4C3 2.89543 3.89543 2 5 2H11C12.1046 2 13 2.89543 13 4V9C13 10.1046 12.1046 11 11 11H7L4 14V11H5C3.89543 11 3 10.1046 3 9V4Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </Icon>
);

// ============================================
// CATEGORY ICONS - Clean single-color icons
// ============================================

// Terminal/System icon
export const TerminalIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <rect x="2" y="3" width="12" height="10" rx="1.5" stroke={color} strokeWidth="1.5"/>
    <path d="M5 7L7 9L5 11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 11H11" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Code/Brackets icon
export const CodeIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path d="M5 4L2 8L5 12" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 4L14 8L11 12" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 3L7 13" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Globe/Web icon
export const GlobeIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.5"/>
    <ellipse cx="8" cy="8" rx="2.5" ry="6" stroke={color} strokeWidth="1.5"/>
    <path d="M2 8H14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M3.5 4.5H12.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M3.5 11.5H12.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Brain/Memory icon
export const BrainIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M8 14V10M8 10C6.5 10 5 9 5 7C5 5 6 4 7 4C7 3 8 2 9 2C10 2 11 2.5 11 4C12 4 13 5 13 7C13 9 11.5 10 10 10M8 10H6C5.5 10 5 10.5 5 11V13C5 13.5 5.5 14 6 14H10C10.5 14 11 13.5 11 13V11C11 10.5 10.5 10 10 10H8Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <circle cx="7" cy="6" r="0.5" fill={color}/>
    <circle cx="10" cy="6" r="0.5" fill={color}/>
  </Icon>
);

// Database/Memory icon (alternative)
export const DatabaseIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <ellipse cx="8" cy="4" rx="5" ry="2" stroke={color} strokeWidth="1.5"/>
    <path d="M3 4V12C3 13.1 5.24 14 8 14C10.76 14 13 13.1 13 12V4" stroke={color} strokeWidth="1.5"/>
    <path d="M3 8C3 9.1 5.24 10 8 10C10.76 10 13 9.1 13 8" stroke={color} strokeWidth="1.5"/>
  </Icon>
);

// Image/Multi-modal icon
export const ImageIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <rect x="2" y="3" width="12" height="10" rx="1.5" stroke={color} strokeWidth="1.5"/>
    <circle cx="5.5" cy="6.5" r="1.5" stroke={color} strokeWidth="1.5"/>
    <path d="M14 10L11 7L6 12H14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

// Cloud/AWS icon
export const CloudIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M4 12H12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6C12 3.79 10.21 2 8 2C5.79 2 4 3.79 4 6C2.34 6 1 7.34 1 9C1 10.66 2.34 12 4 12Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </Icon>
);

// Package/Box icon
export const PackageIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M2.5 5L8 2L13.5 5V11L8 14L2.5 11V5Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path d="M8 8V14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M2.5 5L8 8L13.5 5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M5.25 3.5L10.75 6.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Wrench/Utilities icon (simpler than ToolsIcon)
export const WrenchIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path 
      d="M12 2.5C11.2 2.5 10.5 2.8 9.9 3.3L5.5 7.7C5 7.6 4.5 7.5 4 7.5C2.3 7.5 1 8.8 1 10.5C1 10.8 1 11.1 1.1 11.4L3 9.5L4.5 11L2.6 12.9C2.9 13 3.2 13 3.5 13C5.2 13 6.5 11.7 6.5 10C6.5 9.5 6.4 9 6.3 8.5L10.7 4.1C11.2 3.5 12 3 13 3C13.3 3 13.5 3 13.7 3.1L12 4.8L12.2 6.8L14.2 7L15.9 5.3C16 5.5 16 5.7 16 6C16 7 15.5 7.8 14.9 8.3L10.5 12.7C10.6 13.2 10.5 13.7 10.5 14.2C10.5 14.8 10.2 15 9.5 15C9 15 8.5 14.7 8.5 14" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </Icon>
);

// Cog/Gear icon (simpler settings)
export const CogIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <circle cx="8" cy="8" r="2" stroke={color} strokeWidth="1.5"/>
    <path 
      d="M8 1.5V3M8 13V14.5M14.5 8H13M3 8H1.5M12.6 3.4L11.5 4.5M4.5 11.5L3.4 12.6M12.6 12.6L11.5 11.5M4.5 4.5L3.4 3.4" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round"
    />
  </Icon>
);

// Layers icon (for multi-modal)
export const LayersIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <path d="M8 2L2 5L8 8L14 5L8 2Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 8L8 11L14 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 11L8 14L14 11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

// CPU/Chip icon (for system)
export const CpuIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <rect x="4" y="4" width="8" height="8" rx="1" stroke={color} strokeWidth="1.5"/>
    <rect x="6" y="6" width="4" height="4" stroke={color} strokeWidth="1.5"/>
    <path d="M6 4V2M10 4V2M6 14V12M10 14V12M4 6H2M4 10H2M14 6H12M14 10H12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// Workflow/Flow icon (for agents)
export const WorkflowIcon = ({ size = 16, color = 'currentColor' }) => (
  <Icon size={size}>
    <rect x="2" y="2" width="4" height="4" rx="1" stroke={color} strokeWidth="1.5"/>
    <rect x="10" y="2" width="4" height="4" rx="1" stroke={color} strokeWidth="1.5"/>
    <rect x="6" y="10" width="4" height="4" rx="1" stroke={color} strokeWidth="1.5"/>
    <path d="M4 6V8H8V10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 6V8H8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

export default {
  ToolsIcon,
  SettingsIcon,
  ExecuteIcon,
  AgentIcon,
  FolderIcon,
  SaveIcon,
  OpenIcon,
  TrashIcon,
  SwarmIcon,
  GraphIcon,
  PlusIcon,
  CloseIcon,
  SearchIcon,
  ChevronDownIcon,
  TargetIcon,
  EditIcon,
  LightbulbIcon,
  InfoIcon,
  ChatIcon,
  // Category icons
  TerminalIcon,
  CodeIcon,
  GlobeIcon,
  BrainIcon,
  DatabaseIcon,
  ImageIcon,
  CloudIcon,
  PackageIcon,
  WrenchIcon,
  CogIcon,
  LayersIcon,
  CpuIcon,
  WorkflowIcon,
};

